var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3 mt-5"},[_c('b-container',{staticClass:"mt-5"},[_c('h1',{staticClass:"text-primary font-weight-bold text-center mb-5"},[_vm._v(_vm._s(_vm.$t('login.title')))]),_c('login-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }